import React from 'react'


export class ShippingsView extends React.Component{

    render(){
        return(
            <h1>Shipping Orders</h1>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Logistic/ShippingsView.js